import { render, staticRenderFns } from "./MassDismissCard.vue?vue&type=template&id=14dfee2a&"
import script from "./MassDismissCard.vue?vue&type=script&lang=js&"
export * from "./MassDismissCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports